export default __webpack_public_path__ + "static/media/blob.8f09c82c.svg";